mutation ReconnectBot($botUserId: ID!) {
  result: StreamToolsReconnectBot(botUserId: $botUserId) {
    bot {
      userId
      login
      displayName
      scopes
      connectedAt
      needsReauth
      lastRevocationReason
      lastRevocationAt
    }
    channels {
      channelLogin
      status
      newSubscriptionId
      error
    }
  }
}
